import * as React from 'react';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const IconChevronRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.96967 18.0303C5.67678 17.7374 5.67678 17.2626 5.96967 16.9697L12.9393 10L5.96967 3.03033C5.67678 2.73744 5.67678 2.26256 5.96967 1.96967C6.26256 1.67678 6.73744 1.67678 7.03033 1.96967L14.5295 9.46882L14.5303 9.46962C14.6709 9.61027 14.75 9.80109 14.75 10C14.75 10.1989 14.671 10.3897 14.5303 10.5303L7.03033 18.0303C6.73744 18.3232 6.26256 18.3232 5.96967 18.0303Z",
  fill: "black"
}));
export { IconChevronRight };